/* ============================= */
/* VERSION V1.1 - SECTION À PROPOS */
/* ============================= */

import React from "react";
import "../styles/Apropos.css";

const Apropos = () => {
  return (
    <section className="apropos" id="apropos" aria-labelledby="apropos-title">
      <div className="apropos__container">
        <header className="apropos__header">
          <h2 id="apropos-title" className="apropos__title">
            À propos
          </h2>

          {/* SEO discret (Belfort + Buc, sans l’afficher en gros) */}
          <span className="sr-only">
            Taxi Belfort – Taxi de la Douce. Service premium à Belfort et Buc 90800 :
            gare de Belfort, aéroport Bâle-Mulhouse, longue distance, réservation 24h/24.
          </span>

          <p className="apropos__subtitle">
            Chauffeur professionnel : ponctualité, discrétion, confort premium.
          </p>
        </header>

        <div className="apropos__grid">
          <div className="apropos__content">
            <p className="apropos__text">
              <strong>Taxi de la Douce</strong> propose un service fiable et soigné pour vos trajets
              du quotidien, vos déplacements professionnels et vos transferts (gare, aéroport,
              longue distance).
            </p>

            <p className="apropos__text">
              Mon objectif : une expérience simple et agréable — prise en charge claire,
              conduite souple, véhicule propre et communication rapide par téléphone ou WhatsApp.
            </p>

            <div className="apropos__stats" role="list" aria-label="Engagements">
              <div className="apropos__stat" role="listitem">
                <div className="apropos__statValue">Ponctuel</div>
                <div className="apropos__statLabel">Prise en charge</div>
              </div>
              <div className="apropos__stat" role="listitem">
                <div className="apropos__statValue">24/7</div>
                <div className="apropos__statLabel">Sur réservation</div>
              </div>
              <div className="apropos__stat" role="listitem">
                <div className="apropos__statValue">Premium</div>
                <div className="apropos__statLabel">Confort & discrétion</div>
              </div>
            </div>

            <div className="apropos__cta">
              <a className="btn-gold" href="#reservation">
                Réserver
              </a>

              <a className="btn-ghost" href="tel:+33749424919" aria-label="Appeler le taxi">
                Appeler
              </a>

              <a
                className="btn-ghost"
                href="https://wa.me/33749424919"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contacter sur WhatsApp"
              >
                WhatsApp
              </a>
            </div>

            <p className="apropos__contact">
              <span>📞 +33 7 49 42 49 19</span>
              <span className="apropos__dot">•</span>
              <a className="apropos__mail" href="mailto:taxibuc90@gmail.com">
                taxibuc90@gmail.com
              </a>
            </p>
          </div>

          {/* Remplace “Zones desservies” par une carte pro */}
          <aside className="apropos__card" aria-label="Engagements de service">
            <h3 className="apropos__cardTitle">Engagements</h3>
            <ul className="apropos__list">
              <li>Véhicule propre, récent et entretenu</li>
              <li>Conduite souple, trajet confortable</li>
              <li>Discrétion et service professionnel</li>
              <li>Réservation simple (appel / WhatsApp)</li>
            </ul>

            <div className="apropos__badge" aria-label="Service premium">
              Service premium • Réponse rapide
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default Apropos;
